import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <h3>Diba Mizan</h3>
          <p>Architecture & Interior Design</p>
        </div>
        <div className="footer-text">
          <p>&copy; {new Date().getFullYear()} Diba Mizan. All rights reserved.</p>
          <p>Creating timeless spaces through minimalist design</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

